import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-owl',
  templateUrl: './blog-owl.component.html',
  styleUrls: ['./blog-owl.component.scss']
})
export class BlogOwlComponent implements OnInit {
  @Input() blogList!: any[];
  customOptions: any = {
      items: 2,
      dots: false,
      nav: false,
      autoplay: true,
      autoplayTimeout: 3000,
      loop: true,
      margin: 30,
      responsive: {
          0: { items: 1 },
          768: { items: 2 },
          1024: { items: 3 }
    }
   
  }
  constructor() { }

  ngOnInit(): void {
  }

}
